import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../hooks/useAuth';
import * as XLSX from 'xlsx';

const tipLabel = { faturali_vet: 'Faturalı Vet', faturasiz_vet: 'Faturasız Vet', klinik: 'Vet. Hekim', bireysel: 'Bireysel', bayi: 'Bayi', diger: 'Diğer' };
const tipBadge = { faturali_vet: 'badge-blue', faturasiz_vet: 'badge-yellow', klinik: 'badge-purple', bireysel: 'badge-green', bayi: 'badge-orange', diger: 'badge-gray' };

export default function Musteriler() {
  const { profil } = useAuth();
  const navigate = useNavigate();
  const [musteriler, setMusteriler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [arama, setArama] = useState('');
  const [filtreTip, setFiltreTip] = useState('');
  const [filtreSehir, setFiltreSehir] = useState('');
  const [form, setForm] = useState({ ad: '', telefon: '', email: '', sehir: '', ilce: '', bolge: '', adres: '', musteri_tipi: 'faturasiz_vet', vergi_no: '', vergi_dairesi: '' });
  const [duzenle, setDuzenle] = useState(null);

  useEffect(() => { fetchMusteriler(); }, []);

  async function fetchMusteriler() {
    let q = supabase.from('musteriler').select('*, kullanicilar(ad, soyad)').eq('aktif', true).order('ad');
    if (profil?.rol === 'temsilci') q = q.eq('temsilci_id', profil.id);
    const { data } = await q;
    setMusteriler(data || []);
    setLoading(false);
  }

  async function handleKaydet() {
    if (!form.ad) return;
    const payload = { ...form, temsilci_id: profil?.id };
    if (duzenle) { await supabase.from('musteriler').update(payload).eq('id', duzenle); }
    else { await supabase.from('musteriler').insert(payload); }
    setModal(false);
    fetchMusteriler();
  }

  async function handleSil(id) {
    if (!window.confirm('Bu müşteriyi silmek istediğinizden emin misiniz?')) return;
    await supabase.from('musteriler').delete().eq('id', id);
    fetchMusteriler();
  }

  function duzenleAc(m) {
    setForm({ ad: m.ad, telefon: m.telefon || '', email: m.email || '', sehir: m.sehir || '', ilce: m.ilce || '', bolge: m.bolge || '', adres: m.adres || '', musteri_tipi: m.musteri_tipi, vergi_no: m.vergi_no || '', vergi_dairesi: m.vergi_dairesi || '' });
    setDuzenle(m.id);
    setModal(true);
  }

  const sehirler = [...new Set(musteriler.map(m => m.sehir).filter(Boolean))].sort();
  const filtreli = musteriler.filter(m => {
    if (arama && !m.ad.toLowerCase().includes(arama.toLowerCase()) && !(m.telefon || '').includes(arama)) return false;
    if (filtreTip && m.musteri_tipi !== filtreTip) return false;
    if (filtreSehir && m.sehir !== filtreSehir) return false;
    return true;
  });

  function excelExport() {
    const rows = filtreli.map(m => ({ 'Ad': m.ad, 'Telefon': m.telefon, 'Şehir': m.sehir, 'Tip': tipLabel[m.musteri_tipi], 'Temsilci': `${m.kullanicilar?.ad || ''} ${m.kullanicilar?.soyad || ''}` }));
    const ws = XLSX.utils.json_to_sheet(rows); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'Müşteriler'); XLSX.writeFile(wb, 'musteriler.xlsx');
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <div>
          <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Müşteriler</h1>
          <p style={{ fontSize: 12, color: 'var(--text2)', margin: 0 }}>{filtreli.length} müşteri</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-ghost btn-sm" onClick={excelExport}>📊</button>
          <button className="btn btn-primary btn-sm" onClick={() => { setForm({ ad: '', telefon: '', email: '', sehir: '', ilce: '', bolge: '', adres: '', musteri_tipi: 'faturasiz_vet', vergi_no: '', vergi_dairesi: '' }); setDuzenle(null); setModal(true); }}>+ Yeni</button>
        </div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
        <input className="input" placeholder="Ad veya telefon ara..." value={arama} onChange={e => setArama(e.target.value)} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          <select className="select" value={filtreTip} onChange={e => setFiltreTip(e.target.value)}>
            <option value="">Tüm Tipler</option>
            <option value="faturali_vet">Faturalı Vet</option>
            <option value="faturasiz_vet">Faturasız Vet</option>
            <option value="klinik">Vet. Hekim</option>
            <option value="bireysel">Bireysel</option>
            <option value="bayi">Bayi</option>
          </select>
          <select className="select" value={filtreSehir} onChange={e => setFiltreSehir(e.target.value)}>
            <option value="">Tüm Şehirler</option>
            {sehirler.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        {(arama || filtreTip || filtreSehir) && <button className="btn btn-ghost btn-sm" onClick={() => { setArama(''); setFiltreTip(''); setFiltreSehir(''); }}>✕ Temizle</button>}
      </div>

      {loading ? <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Yükleniyor...</div>
        : filtreli.length === 0 ? <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Müşteri bulunamadı</div>
        : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {filtreli.map(m => (
              <div key={m.id} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                  <div onClick={() => navigate(`/musteriler/${m.id}`)} style={{ cursor: 'pointer', flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 15 }}>{m.ad}</div>
                    <div style={{ fontSize: 12, color: 'var(--text2)' }}>{m.telefon || '-'} • {m.sehir || '-'}</div>
                  </div>
                  <span className={`badge ${tipBadge[m.musteri_tipi]}`} style={{ fontSize: 10 }}>{tipLabel[m.musteri_tipi]}</span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={() => navigate(`/musteriler/${m.id}`)}>Detay</button>
                  <button className="btn btn-ghost btn-sm" style={{ flex: 1 }} onClick={() => duzenleAc(m)}>Düzenle</button>
                  <button className="btn btn-danger btn-sm" onClick={() => handleSil(m.id)}>Sil</button>
                </div>
              </div>
            ))}
          </div>
        )}

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <div className="modal" style={{ maxWidth: 500 }} onClick={e => e.stopPropagation()}>
            <h3 className="modal-title">{duzenle ? 'Müşteri Düzenle' : 'Yeni Müşteri'}</h3>
            <div className="form-group"><label className="label">Ad Soyad / Klinik Adı *</label><input className="input" value={form.ad} onChange={e => setForm(f => ({ ...f, ad: e.target.value }))} autoFocus /></div>
            <div className="form-group"><label className="label">Müşteri Tipi</label><select className="select" value={form.musteri_tipi} onChange={e => setForm(f => ({ ...f, musteri_tipi: e.target.value }))}><option value="faturali_vet">Faturalı Veteriner</option><option value="faturasiz_vet">Faturasız Veteriner</option><option value="klinik">Veteriner Hekim</option><option value="bireysel">Bireysel</option><option value="bayi">Bayi</option><option value="diger">Diğer</option></select></div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
              <div className="form-group"><label className="label">Telefon</label><input className="input" value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value.slice(0,15) }))} /></div>
              <div className="form-group"><label className="label">Şehir</label><input className="input" value={form.sehir} onChange={e => setForm(f => ({ ...f, sehir: e.target.value }))} /></div>
              <div className="form-group"><label className="label">İlçe</label><input className="input" value={form.ilce} onChange={e => setForm(f => ({ ...f, ilce: e.target.value }))} /></div>
              <div className="form-group"><label className="label">Bölge</label><input className="input" value={form.bolge} onChange={e => setForm(f => ({ ...f, bolge: e.target.value }))} /></div>
            </div>
            <div className="form-group"><label className="label">Adres</label><textarea className="textarea" value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} /></div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn btn-ghost" onClick={() => setModal(false)}>İptal</button>
              <button className="btn btn-primary" onClick={handleKaydet} disabled={!form.ad}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
